import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../shared/custom-button/custom-button";
import { BUTTON_VARIANTS } from "../../constants/styles";
import { routes } from "../../constants/routes";
import { VIEWS } from "../../constants/global";
import "./new-hero-section.scss";

interface NewHeroSectionProps {
  mainTitle?: string;
  subtitle?: string;
  description?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  descriptionText?: string;
}

const NewHeroSection: React.FC<NewHeroSectionProps> = ({
  mainTitle = "Smart Thinking, Bold Coding.",
  subtitle = "Build your idea with us.",
  description = "We build software that transforms businesses and creates lasting value.",
  primaryButtonText = "Cases",
  secondaryButtonText = "See Services",
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  descriptionText = "We build software that transforms businesses and creates lasting value.",
}) => {
  const navigate = useNavigate();

  const handlePrimaryButtonClick = () => {
    if (onPrimaryButtonClick) {
      onPrimaryButtonClick();
    } else {
      navigate(routes[VIEWS.OUR_WORK].staticPath);
    }
  };

  const handleSecondaryButtonClick = () => {
    if (onSecondaryButtonClick) {
      onSecondaryButtonClick();
    } else {
      navigate(routes[VIEWS.SERVICES].staticPath);
    }
  };

  return (
    <div className="NewHeroSection">
      <div className="NewHeroSection-background">
        <img 
          src="/hero-bg.png" 
          alt="Hero Background" 
          className="NewHeroSection-background-image"
        />
      </div>
      
      <div className="NewHeroSection-main">
        <div className="NewHeroSection-titles">
          <h1 className="NewHeroSection-title">
            <span className="NewHeroSection-title-line">Smart Thinking,</span>
            <span className="NewHeroSection-title-line">Bold Coding.</span>
          </h1>
          <h2 className="NewHeroSection-subtitle">{subtitle}</h2>
        </div>

        <div className="NewHeroSection-actions">
          <CustomButton
            className="NewHeroSection-primary-button"
            btnVariant={BUTTON_VARIANTS.PRIMARY}
            onClick={handlePrimaryButtonClick}
          >
            {primaryButtonText}
          </CustomButton>
          <button
            className="NewHeroSection-secondary-button"
            onClick={handleSecondaryButtonClick}
          >
            {secondaryButtonText}
          </button>
        </div>
      </div>

      <div className="NewHeroSection-description-area">
        <div className="NewHeroSection-description-spacer"></div>
        <div className="NewHeroSection-description">
          <p className="NewHeroSection-description-text">{descriptionText}</p>
        </div>
      </div>
    </div>
  );
};

export default NewHeroSection; 